import * as React from 'react';
import {
	AutocompleteInput,
	Edit,
	EditProps,
	NumberInput,
	ReferenceInput,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';
import { ELanguage } from '../enums';
import { CustomFileInput } from "../components/CustomFileInput";

export const CoachGuideEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<UploadImage step={1} source="imageUrl" label="IMAGE"/>
				<CustomFileInput step={1} source="fileUrl" label="FILE"/>
				<TextInput step={1} source="title" label="TITLE"/>
				<TextInput multiline step={1} source="description" label="DESCRIPTION"/>
				<ReferenceInput
					step={1}
					label="CATEGORY"
					source="categoryId" reference="coach-guide-categories"
					alwaysOn
				>
					<AutocompleteInput optionText="name"/>
				</ReferenceInput>

				<TextInput type="url" step={1} source="videoUrl" label="YOUTUBE_LINK"/>
				<TextInput type="url" step={1} source="externalUrl" label="EXTERNAL_LINK"/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Edit>
	);
};
